module.exports = require("opentype.js");